import { AppBar, Box, Button, Drawer, IconButton, Menu, MenuItem, Toolbar, Link as MuiLink } from '@mui/material';
import { Container } from '@mui/system';
import images from 'assets/images';
import { HeaderDrawer } from 'layout';
import React from 'react';
import { useSelector } from 'react-redux';
import ScrollSpy from 'react-scrollspy-navigation';
import { Routing } from 'shared/constants/routing';
import { IApplicationState } from 'store/state/app-state';
import { Link, useHistory, useLocation } from 'react-router-dom';

const drawerWidth = 260;

const Header: React.FC = () => {
    const setting = useSelector((state: IApplicationState) => state?.Setting);
    const spanRef = React.useRef(null);
    const history = useHistory();

    const location = useLocation();

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleDrawerToggle = () => setMobileOpen((prevState) => !prevState);

    const handleActionOpen = () => setAnchorEl(spanRef.current);
    // const handleActionOpen = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event?.currentTarget);
    const handleActionClose = () => setAnchorEl(null);

    const handleClinicianLoginClick = () => {
        handleActionClose();
        window.open(setting?.cliniciaN_PORTAL_APPLICATION_URL, '_blank');
    };

    const handlePatientLoginClick = () => {
        handleActionClose();
        window.open(setting?.patienT_PORTAL_APPLICATION_URL, '_blank');
    };

    const renderMenu = () => {
        return (
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleActionClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className="user-dropdown"
            >
                <MenuItem onClick={handleClinicianLoginClick}>
                    <img src={images.dropDownUserOne} alt="User Profile" className="user-profile" />
                    Clinician Login
                </MenuItem>
                <MenuItem onClick={handlePatientLoginClick}>
                    <img src={images.dropDownUserTwo} alt="User Profile" className="user-profile" />
                    Patient Login
                </MenuItem>
            </Menu>
        );
    };

    const handleNavClick = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        if (history.location.pathname === Routing.Clinicians) {
            event.preventDefault();
            history.push({ pathname: Routing.Landing, state: { id } });
        }
    };

    return (
        <>
            <AppBar component="nav" className="header">
                <div className="header-inner-block">
                    <Container className="contanier">
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ display: { lg: 'none' } }}
                                className="nav-toggler"
                            >
                                <img src={images.menuIcon} alt="Icon" />
                            </IconButton>

                            <MuiLink href={Routing.Landing} title="Health Reach" className="navbar-brand">
                                <img src={images.logo} alt="Logo" />
                            </MuiLink>
                            <Box sx={{ display: { xs: 'none', lg: 'block' } }} className="navbar-nav">
                                <ScrollSpy key={location.pathname} offsetTop={80} duration={1500} className="active">
                                    <a
                                        href="#home"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'home')}
                                        className="nav-link"
                                    >
                                        Home
                                    </a>
                                    <a
                                        href="#about-us"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'about-us')}
                                        className="nav-link"
                                    >
                                        About Us
                                    </a>
                                    <a
                                        href="#practice-with-us"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'practice-with-us')}
                                        className="nav-link"
                                    >
                                        Practice With Us
                                    </a>
                                    <a
                                        href="#access-service"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'access-service')}
                                        className="nav-link"
                                    >
                                        Access Clinicians
                                    </a>
                                    <a
                                        href="#news"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'news')}
                                        className="nav-link"
                                    >
                                        Health News
                                    </a>
                                    <a
                                        href="#faq"
                                        ref={React.createRef()}
                                        onClick={(e) => handleNavClick(e, 'faq')}
                                        className="nav-link"
                                    >
                                        FAQ
                                    </a>
                                </ScrollSpy>

                                <Link
                                    to={Routing.Clinicians}
                                    className={`nav-link ${location.pathname === Routing.Clinicians ? 'active' : ''}`}
                                >
                                    Our Clinicians
                                </Link>
                            </Box>
                            <Button
                                ref={spanRef}
                                variant="contained"
                                size="small"
                                title="Login"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleActionOpen}
                                className="login-btn"
                            >
                                Login
                            </Button>
                        </Toolbar>
                    </Container>
                </div>
            </AppBar>
            <Box component="nav">
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', lg: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    <HeaderDrawer handleDrawerToggle={handleDrawerToggle} />
                </Drawer>
            </Box>
            {renderMenu()}
        </>
    );
};

export default Header;
